
import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";

const getScheduledOffline = async (taxAuthorityId, productId, includeExpired) => {
    const params = new URLSearchParams();
    if (taxAuthorityId !== undefined && taxAuthorityId !== null) {
        params.append("taxAuthorityId", taxAuthorityId);
    }
    if (productId !== undefined && productId !== null) {
        params.append("productId", productId);
    }
    params.append("includeExpired", includeExpired);
    const response = await axios.get(`scheduledOffline?${params.toString()}`, {headers: authHeader()});
    return response.data.result;
}

const addScheduledOffline = async (offlineReason, offlineStart, offlineEnd, taxAuthorityId, productId) => {
    const data = {offlineReason, offlineStart, offlineEnd, taxAuthorityId, productId};
    await axios.post('scheduledOffline', data, {headers: authHeader()});
}

const updateScheduledOffline = async (scheduledOfflineId, offlineReason, offlineStart, offlineEnd) => {
    const data = {scheduledOfflineId, offlineReason, offlineStart, offlineEnd};
    await axios.put('scheduledOffline', data, {headers: authHeader()});
}

const deleteScheduledOffline = async (scheduledOfflineId) => {
    await axios.delete(`scheduledOffline/${scheduledOfflineId}`, {headers: authHeader()});
}

export const scheduledOfflineApi = {
    getScheduledOffline,
    addScheduledOffline,
    updateScheduledOffline,
    deleteScheduledOffline
}
